import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { CourseAccessTypeEnum } from '../course'

export enum AutomationRuleActionsEnum {
  add_tag = 'add_tag',
  remove_tag = 'remove_tag',
  subscribe_to_campaign = 'subscribe_to_campaign',
  unsubscribe_from_campaign = 'unsubscribe_from_campaign',
  send_email = 'send_email',
  send_email_to_specific_address = 'send_email_to_specific_address',
  enroll_in_course = 'enroll_in_course',
  revoke_access_to_course = 'revoke_access_to_course',
  enroll_in_course_bundle = 'enroll_in_course_bundle',
  revoke_access_to_course_bundle = 'revoke_access_to_course_bundle',
  send_webhook = 'send_webhook',
  grant_access_to_community = 'grant_access_to_community',
  revoke_access_to_community = 'revoke_access_to_community',
  create_user = 'create_user',
}

export type ActionIdType = number

export interface DefinedActionEmailEditInterface {
  type: AutomationRuleActionsEnum.send_email
  systemeEmail: { id: number; subject: string }
}

export interface ActionEmailEditInterface {
  type: AutomationRuleActionsEnum.send_email
  systemeEmail: { id?: number; subject?: string }
}

export interface DefinedActionSpecEmailEditInterface {
  type: AutomationRuleActionsEnum.send_email_to_specific_address
  emailMessageWithRecipient: {
    id: number
    mailing: { currentEmail: { subject: string; id?: number } }
  }
}

export interface ActionSpecEmailEditInterface {
  type: AutomationRuleActionsEnum.send_email_to_specific_address
  emailMessageWithRecipient: {
    id?: number
    mailing?: { currentEmail: { subject?: string; id?: number } }
  }
}

export interface ActionCreateUserEditInterface {
  type: AutomationRuleActionsEnum.create_user
  locale?: PageLocaleEnum
}

export interface DefinedActionCampaignEditInterface {
  type:
    | AutomationRuleActionsEnum.subscribe_to_campaign
    | AutomationRuleActionsEnum.unsubscribe_from_campaign
  campaign: { id: number; name: string }
}

export interface ActionCampaignEditInterface {
  type:
    | AutomationRuleActionsEnum.subscribe_to_campaign
    | AutomationRuleActionsEnum.unsubscribe_from_campaign
  campaign: { id?: number; name?: string }
}

export interface DefinedActionTagEditInterface {
  type: AutomationRuleActionsEnum.add_tag | AutomationRuleActionsEnum.remove_tag
  tag: { id: number; name: string }
}

export interface ActionTagEditInterface {
  type: AutomationRuleActionsEnum.add_tag | AutomationRuleActionsEnum.remove_tag
  tag: { id?: number; name?: string }
}

export interface ActionWebhookEditInterface {
  type: AutomationRuleActionsEnum.send_webhook
  webhookUrl?: string
}

export interface DefinedActionCourseEditInterface {
  type:
    | AutomationRuleActionsEnum.enroll_in_course
    | AutomationRuleActionsEnum.revoke_access_to_course
  accessType: CourseAccessTypeEnum
  courseAccessType: CourseAccessTypeEnum
  course: { id: number; name: string }
}

export interface DefinedActionCourseBundleEditInterface {
  type:
    | AutomationRuleActionsEnum.enroll_in_course_bundle
    | AutomationRuleActionsEnum.revoke_access_to_course_bundle
  enrollmentAccessType: CourseAccessTypeEnum
  courseBundle: { id: number; name: string }
}

export interface ActionCourseEditInterface {
  type:
    | AutomationRuleActionsEnum.enroll_in_course
    | AutomationRuleActionsEnum.revoke_access_to_course
  courseAccessType?: CourseAccessTypeEnum
  course: { id?: number; name?: string }
}

export interface ActionCourseBundleEditInterface {
  type:
    | AutomationRuleActionsEnum.enroll_in_course_bundle
    | AutomationRuleActionsEnum.revoke_access_to_course_bundle
  enrollmentAccessType?: CourseAccessTypeEnum
  courseBundle: { id?: number; name?: string }
}

export interface DefinedActionCommunityEditInterface {
  type:
    | AutomationRuleActionsEnum.grant_access_to_community
    | AutomationRuleActionsEnum.revoke_access_to_community
  community: { id: number; name: string }
}

export interface ActionCommunityEditInterface {
  type:
    | AutomationRuleActionsEnum.grant_access_to_community
    | AutomationRuleActionsEnum.revoke_access_to_community
  community: { id?: number; name?: string }
}

export type ActionApiType = { id: ActionIdType } & (
  | DefinedActionEmailEditInterface
  | DefinedActionTagEditInterface
  | ActionWebhookEditInterface
  | DefinedActionCourseEditInterface
  | DefinedActionCourseBundleEditInterface
  | DefinedActionCampaignEditInterface
  | ActionCreateUserEditInterface
  | DefinedActionSpecEmailEditInterface
  | DefinedActionCommunityEditInterface
)

export type CommonActionType =
  | ActionEmailEditInterface
  | ActionTagEditInterface
  | ActionWebhookEditInterface
  | ActionCourseEditInterface
  | ActionCourseBundleEditInterface
  | ActionCampaignEditInterface
  | ActionCreateUserEditInterface
  | ActionSpecEmailEditInterface
  | ActionCommunityEditInterface

export type ActionSaveType = {
  id: ActionIdType
  created?: boolean
} & CommonActionType

export type ActionSaveApiType = { id?: ActionIdType } & CommonActionType
